export class MarkdownUtility {

    public static parseLinkMarkdown(markdown: string) {
        //eslint-disable-next-line
        markdown = markdown.replace(/[\[]{1}([^\]]+)[\]]{1}[\(]{1}([^\)\"]+)(\"(.+)\")?[\)]{1}/g, '<a href="$2" target="_blank" title="$4">$1</a>');
        return markdown;
    }
}